import Vue from 'vue'

import 'normalize.css/normalize.css'
import 'animate.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import uploader from 'vue-simple-uploader'
  
import App from './App'
import {
  router
} from './router'
import store from './store'

import './icons'

import util from '@/base/js/util'

//自动获取剪切容器
VueClipboard.config.autoSetContainer = true

Vue.use(ElementUI)

Vue.use(VueClipboard)

Vue.use(uploader)

Vue.use(preview, {
  bgOpacity: 0.8,
})


Vue.config.productionTip = false

Vue.directive('permission', {
  inserted: (el, binding, vnode) => {
    const id = binding.value
    const hassPermission = util.isPermission(id, store.state.userInfo.auth_list)
    if (!hassPermission) {
      el.parentNode.removeChild(el)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
